import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MetricCardModel } from '../../core/models/dashboard.model';

/**
 * Card genérico de métrica — rótulo + valor já formatado, com faixa de
 * severidade e ícone. Não conhece chamado, título a receber ou pedido:
 * reutilizável por qualquer dashboard derivado de listagem (chamados, geral,
 * financeiro, vendas). Quem monta o `MetricCardModel` decide o que o valor
 * significa e como formatá-lo — este componente só exibe.
 *
 * Clicável de verdade somente quando `model().target` existe e o card não
 * está `loading`; nesse caso renderiza um `<button>` real (foco e ativação
 * por teclado nativos, sem `role`/`tabindex` manuais). Sem destino, ou
 * carregando, renderiza um `<div>` que não finge ser interativo.
 */
@Component({
  selector: 'app-metric-card',
  standalone: true,
  imports: [NgTemplateOutlet],
  templateUrl: './metric-card.component.html',
  styleUrls: ['./metric-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MetricCardComponent {
  readonly model = input.required<MetricCardModel>();
  readonly loading = input(false);

  readonly cardClick = output<MetricCardModel>();

  /** Só é clicável com destino definido e fora do estado de carregamento. */
  readonly clickable = computed(() => !!this.model().target && !this.loading());

  onActivate(): void {
    if (this.clickable()) {
      this.cardClick.emit(this.model());
    }
  }
}
